@for (item of fabs(); track $index) {
<button class="fab"
        type="button"
        [style]="item.style"
        (click)="item?.action()"
        [attr.aria-label]="item.title"
        [attr.icon]="item.svg">
  @if(item.badge) {
  <span class="badge"
        [attr.aria-label]="item.badge.title"
        [attr.icon]="item.badge.icon"></span>
  }
</button>
}
